export function Component() {
  return <div>Procedure detail preference cards</div>;
}
